import { Item } from "@/dto/item";
import { Merchant } from "@/dto/merchant";
import { redirect } from "next/navigation";

export const giftCardCategory = {
  id: "GIFTCARD",
  name: "Gift Card",
  numberOfItems: 1,
  sortOrder: 0,
  items: ["GIFTCARD_ITEM"],
};

export const giftCardItem: Item = {
  id: "GIFTCARD_ITEM",
  name: "Digital Gift Card",
  options: [],
  price: 0,
  modifierGroupIds: [],
  categoryIds: [giftCardCategory.id],
  taxIds: [],
  images: [],
  available: true,
  serviceItem: [],
  modifiedTime: Date.now(),
  isAgeRestricted: false,
};

export const giftCardRoute: string = "/giftcard";

export const isStandaloneGiftCardWebsite = (
  merchant?: Merchant | null
): boolean => {
  if (!merchant) {
    return false;
  }
  return merchant?.isSellingGiftCards && merchant?.services?.length === 0;
};

export const redirectStandaloneGiftCard = (merchant: Merchant) => {
  if (merchant?.services?.length === 0 && merchant.isSellingGiftCards) {
    redirect(giftCardRoute);
  }
};

export const removeGiftCardInfo = () => {
  const giftCard = sessionStorage.getItem("giftCardInfo");
  if (giftCard) {
    sessionStorage.removeItem("giftCardInfo");
  }
};
